import React from 'react';
import ParametroFatorMargemVplAlvoService from '../../../../lib/api/parametroFatorMargemVplAlvo/parametroFatorMargemVplAlvoService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroFatorMargemVplAlvo extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametroFatorMargemVplAlvo()
    {
        return ParametroFatorMargemVplAlvoService.obterExcel()
    }

    enviarParametrosEventGrid()
    {
        return ParametroFatorMargemVplAlvoService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametroFatorMargemVplAlvo}
                enviarExcelParametros={ParametroFatorMargemVplAlvoService.salvarExcelParametroFatorMargemVplAlvo}
                deletarExcelParametros={ParametroFatorMargemVplAlvoService.deletarExcelParametroFatorMargemVplAlvo}
                nomeDoArquivo='Parametros Fator Margem Alvo e Vpl Alvo'
            ></TemplateParametro>
        );
    }
}

export default ParametroFatorMargemVplAlvo;